import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InitialStockRegistration } from '../../../types/inventory/InitialStockTypes';

/**
 * Estado global para la gestión de registro de existencias iniciales.
 */
interface InitialStockState {
    form: InitialStockRegistration;
    isSubmitting: boolean;
    wasRegistered: boolean;
}

/**
 * Estado inicial del formulario de inventario inicial.
 */
const initialState: InitialStockState = {
    form: {
        branchId: null,
        productId: null,
        quantity: null,
        unitCost: null,
    },
    isSubmitting: false,
    wasRegistered: false,
};


/**
 * Slice de Inventario Inicial
 */
const initialStockSlice = createSlice({
    name: 'initialStock',
    initialState,
    reducers: {
        setForm(state, action: PayloadAction<Partial<InitialStockRegistration>>) {
            state.form = { ...state.form, ...action.payload };
        },
        resetForm(state) {
            state.form = initialState.form;
            state.wasRegistered = false;
        },
        setIsSubmitting(state, action: PayloadAction<boolean>) {
            state.isSubmitting = action.payload;
        },
        setWasRegistered(state, action: PayloadAction<boolean>) {
            state.wasRegistered = action.payload;
        },
    },
});

// Exportaciones
export const { setForm, resetForm, setIsSubmitting, setWasRegistered } = initialStockSlice.actions;
export default initialStockSlice.reducer;
